module.exports = __webpack_public_path__ + "img/confinement-5.c783115.jpeg";